/**
 * Created by Abner Sui on 04/10/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { RelationshipDisplayType, TileColumn, TileColumnDataType, TileColumnSetting } from '../../../../tamalelibs/models/tile-column.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { RelationshipType } from '../../../../tamalelibs/models/relationship-type.model';
import { EntityType } from '../../../../tamalelibs/models/entity-type.model';
import { Store, select } from '@ngrx/store';
import { take, filter } from 'rxjs/operators';
import { fullEntityTypeSelector } from '../../../../redux/reducers/entity-type.reducer';
import { relationshipTypeSelector } from '../../../../redux/reducers/relationship-type.reducer';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { businessConstants } from '../../../../tamalelibs/constants/business.constants';
import { businessConstants as webBusinessConstants } from '../../../../constants/business.constants';
import { validRelationshipTypeReducer, validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import { ValidRelationshipType } from '../../../../tamalelibs/models/valid-relationship-type.model';
import { ArrayHelperService } from '../../../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'tile-relationship-column-detail',
    templateUrl: './tile-relationship-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileRelationshipColumnDetailComponent implements OnInit, OnDestroy {

    @Input()
    config: TileColumn;
    @Input()
    wholeConfig: TileModel;

    displayList: Array<BriefObject>;
    isSearchByRelationship = false;
    isDisabledCheckEmployment = false;
    selectedDisplay: BriefObject;
    parameterValueList: Array<BriefObject> = [];
    selectedParameterValue: BriefObject;
    relationshipTypeList: Array<RelationshipType> = [];
    selectedRelationshipType: RelationshipType = null;
    entityTypeList: Array<EntityType> = [];
    selectedEntityType: EntityType;
    totalValidRelationshipType: Array<ValidRelationshipType>;

    constructor(
        private _store: Store<any>,
    ) { }

    ngOnInit(): void {
        this.displayList = webBusinessConstants.displayList;
        this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
        this.wholeConfig.columns.forEach(item => {
            if (item.dataType === TileColumnDataType.ENTITY && item.guid !== this.config.guid) {
                this.parameterValueList.push(new BriefObject(item.guid, item.title));
            }
        });
        this.selectedParameterValue = this.parameterValueList.find(item => item.id === this.config.config.parameterValue);
        this._store.pipe(select(validRelationshipTypeSelector),
            take(1)
        ).subscribe(res => {
            this.totalValidRelationshipType = res;
        });
        this._store.pipe(select(relationshipTypeSelector),
            take(1)
        ).subscribe(res => {
            this.relationshipTypeList = [];
            this.relationshipTypeList.push(...res);
            ArrayHelperService.sort(this.relationshipTypeList, 'name');
            if (this.config.relationshipType) {
                this.selectedRelationshipType = this.relationshipTypeList.find(item => item.id === this.config.relationshipType);
                this._checkEmploymentStatus();
            }
            // according server design 1 means
            if (this.config.relationshipDisplayType === RelationshipDisplayType.INCLUDE) {
                this.isSearchByRelationship = true;
            } else {
                this.isSearchByRelationship = false;
            }
        });
        this._store.pipe(select(fullEntityTypeSelector),
            filter(res => res),
            take(1)
        ).subscribe(res => {
            this.entityTypeList = [];
            this.entityTypeList.push({ id: '', name: '' });
            ArrayHelperService.sort(res, 'name');
            this.entityTypeList.push(...res);
            if (this.config.entityTypeFilter) {
                this.selectedEntityType = this.entityTypeList.find(item => item.id === this.config.entityTypeFilter);
            } else {
                this.selectedEntityType = this.entityTypeList[0];
            }
        });
    }

    ngOnDestroy(): void {
    }

    onDisplayChange(value) {
        this.selectedDisplay = value;
        if (!this.config.settings) {
            this.config.settings = new TileColumnSetting();
        }
        this.config.settings.display = this.selectedDisplay.id;
    }

    onEntityTypeChange(value) {
        this.selectedEntityType = value;
        if (this.selectedEntityType.id) {
            this.config.entityTypeFilter = this.selectedEntityType.id;
        } else {
            delete this.config.entityTypeFilter;
        }
    }

    onParameterValueChange(value) {
        this.selectedParameterValue = value;
        this.config.config.parameterValue = this.selectedParameterValue.id;
    }

    onRelationshipTypeChange(value) {
        this.selectedRelationshipType = value;
        this.config.relationshipType = this.selectedRelationshipType.id;
        this._checkEmploymentStatus();
    }

    getSearchRelationshipStatus(value) {
        if (this.isSearchByRelationship) {
            this.config.relationshipDisplayType = RelationshipDisplayType.INCLUDE;
        } else {
            this.config.relationshipDisplayType = RelationshipDisplayType.EXCLUDE;
        }
    }

    private _checkEmploymentStatus() {
        if (this.totalValidRelationshipType) {
            const validRelationshipList = this.totalValidRelationshipType.filter(item => item.relationshipType.id === this.selectedRelationshipType.id);

            const index = validRelationshipList.findIndex(item => item.childEntityType.id === businessConstants.EntityTypes.Contact_Id && item.parentEntityType.id === businessConstants.EntityTypes.Contact_Id);
            if (index < 0) {
                this.isDisabledCheckEmployment = true;
                this.isSearchByRelationship = false;
                this.config.relationshipDisplayType = RelationshipDisplayType.EXCLUDE;
            } else {
                this.isDisabledCheckEmployment = false;
            }
        }
    }

}
